import { buildApi } from '../../../http-client/http-client';
import withAuth from '../../../auth-service/with-auth';
import { MapperApi2_0 } from '../../../../mappers';
import * as Models from '../../../../models';
import { ApiCommon, Api2_0 } from '../../../../mappers/backend-types';

export interface CreateChallengeBody {
  title: string;
  description: string;
  visibility: Models.ChallengeVisibility;
  deadline: {
    accessTimeLimitMinutes: number | null;
    intervals: {
      datetimeStart: ApiCommon.DateTimeISO8601;
      datetimeFinish: ApiCommon.DateTimeISO8601;
    }[];
  };
  examId: Models.ExamId;
  config: {
    showAlwaysRanking: boolean;
    showAlwaysTestMark: boolean;
    showAlwaysTestQuestions: boolean;
    showFromDatetime: ApiCommon.DateTimeISO8601 | null;
  };
  creator: {
    type: Models.ChallengeCreatorType;
  };
  addAllStudents?: boolean;
  students?: Models.UserId[];
}

export interface CreateChallengeArgs extends CreateChallengeBody {}

export const createChallenge = withAuth<Models.Challenge, [CreateChallengeArgs]>(async (token: string, body) => {
  return buildApi(token)
    .post(`${process.env.API_BASE_URL}/api/v2.0/challenges`, body, true)
    .then((challenge: Api2_0.Challenge) => {
      return MapperApi2_0.mapChallenge(challenge);
    });
});
